import React from 'react';
import axios from 'axios';
import cx from 'classnames';
import PropTypes from 'prop-types';

import {
  CSRF_TOKEN,
  requestCallback,
} from '../lib/helpers';

const UuidLogin  = ({
  userId,
  allowUuidLogin
}) => {
  const toggleUuidLogin = () => {
    requestCallback(axios.put(`/${gon.currentProvider}/api/shared_settings/${userId}`, {
      shared_setting: {
        allow_uuid_login: !allowUuidLogin
      },
      authenticity_token: CSRF_TOKEN,
    }))
  }

  return (
    <div className='UuidLogin'>
      <a
        className='Badge Badge--copy'
        onClick={toggleUuidLogin}
      >
        allow login: <span className={cx('Text Text--bold', !allowUuidLogin && 'Text--gray')}>{allowUuidLogin ? 'on' : 'off'}</span>
      </a>
    </div>
  )
}

UuidLogin.propTypes = {
  userId: PropTypes.number.isRequired,
  allowUuidLogin: PropTypes.bool.isRequired,
}

export default UuidLogin;
